.StompSwitch {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;

    &.isEngaged {
        & .StompSwitch__lamp {
            background: var(--soniq-t--global--palette--hot-pink);
            border-color: var(--soniq-t--global--border--color--status--attention--default);
            box-shadow: 0 0 14px 3px var(--soniq-t--global--background--color--accent--active--default);
        }

        & .StompSwitch__state {
            background: var(--soniq-t--global--background--color--status--danger--default);
            border-color: var(--soniq-t--global--border--color--status--danger--default);
            color: var(--soniq-t--global--text--color--status--danger--default);
        }
    }
}

.StompSwitch__lamp {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: var(--soniq-t--global--background--color--status--muted--default);
    border: 1px solid var(--soniq-t--global--border--color--status--muted--default);
    transition: background 150ms ease, box-shadow 150ms ease;
}

.StompSwitch__button {
    width: 84px;
    height: 84px;
    border-radius: 50%;
    border: 1px solid var(--soniq-t--global--border--color--event--opaque);
    background: radial-gradient(circle at 34% 30%, var(--soniq-t--global--background--color--surface--hover), transparent 60%),
    var(--soniq-t--global--background--color--surface--panel-opaque);
    box-shadow: 0 8px 18px var(--soniq-t--global--text--shadow--subtle);
    cursor: pointer;
    position: relative;
    transition: transform 90ms ease, box-shadow 90ms ease;

    &::before {
        content: "";
        position: absolute;
        inset: 14px;
        border-radius: 50%;
        border: 1px dashed var(--soniq-t--global--border--color--grid--strong);
    }

    &:active {
        transform: translateY(2px) scale(0.98);
        box-shadow: 0 3px 8px var(--soniq-t--global--text--shadow--subtle);
    }

    &:focus-visible {
        outline: 2px solid var(--soniq-t--global--border--color--accent--today--default);
        outline-offset: 4px;
    }
}

.StompSwitch__label {
    font-size: var(--soniq-t--global--font--size--field-label);
    font-weight: var(--soniq-t--global--font--weight--medium);
    letter-spacing: var(--soniq-t--global--font--letter-spacing--wide);
    text-transform: uppercase;
    color: var(--soniq-t--global--text--color--label--default);
}

.StompSwitch__state {
    font-family: var(--soniq-t--global--font--family--mono);
    font-size: var(--soniq-t--global--font--size--field-label);
    letter-spacing: var(--soniq-t--global--font--letter-spacing--wide);
    padding: 2px 10px;
    border-radius: 999px;
    background: var(--soniq-t--global--background--color--status--muted--default);
    border: 1px solid var(--soniq-t--global--border--color--status--muted--default);
    color: var(--soniq-t--global--text--color--status--muted--default);
}

@media (prefers-reduced-motion: reduce) {
    .StompSwitch__lamp,
    .StompSwitch__button {
        transition: none;
    }
}
